<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column prop="StuName" label="学生姓名" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
          <template slot-scope="scope">
            {{ formatDepartmentName(scope.row.DepartmentName) }}
          </template>
        </el-table-column>

        <el-table-column prop="DeviceType" label="设备类型" width="">
          <template slot-scope="scope">
            <span v-if="scope.row.DeviceType">
              <span v-for="(type, idx) in scope.row.DeviceType.split(',')" :key="idx">
                {{ type === '1' ? '洗衣机' : type === '2' ? '吹风机' : type }}
                <span v-if="idx !== scope.row.DeviceType.split(',').length - 1">, </span>
              </span>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="StartTime" label="开始时间" width="">
        </el-table-column>
        <el-table-column prop="EndTime" label="结束时间" width="">
        </el-table-column>

        <el-table-column prop="Remark" label="备注" width="">
        </el-table-column>

        <!-- <el-table-column prop="IsEnabled" label="状态" width="">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsEnabled == 1 ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsEnabled == 1
              ?
              "已启用" : "未启用" }}
            </el-tag>
          </template>
        </el-table-column> -->


        <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width></el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="50" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!--新增界面-->
      <el-dialog title="新增限免用户信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm" class="demo-form-inline">

          <!-- 人员：家校通讯录多选。创建于 2026-09-23 -->
          <el-form-item label="人员" required>
            <div class="ps-pick-summary">
              <span v-if="personSelectedItems.length">已选 <strong>{{ personSelectedItems.length }}</strong> 人
                <template v-if="personSelectedDeptCount">（{{ personSelectedDeptCount }} 个部门）</template>
              </span>
              <span v-else class="muted-text">请从家校通讯录选择学生</span>
              <el-button type="primary" size="small" plain @click="openPersonPicker">选择学生</el-button>
              <el-button v-if="personSelectedItems.length" type="text" size="small" @click="clearPersonSelection">清空</el-button>
            </div>
            <div v-if="personSelectedItems.length" class="ps-pick-tags">
              <el-tag
                v-for="item in personSelectedPreview"
                :key="item.id"
                size="mini"
                closable
                disable-transitions
                @close="removePersonSelected(item.id)">
                {{ item.name }}
              </el-tag>
              <span v-if="personSelectedItems.length > 8" class="ps-pick-more">等 {{ personSelectedItems.length }} 人</span>
            </div>
          </el-form-item>

          <el-form-item label="设备类型" prop="DeviceType">
            <el-checkbox-group v-model="addForm.DeviceType">
              <el-checkbox label="1">洗衣机</el-checkbox>
              <el-checkbox label="2">吹风机</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="限免开始时间" prop="StartTime">
            <el-date-picker v-model="addForm.StartTime" type="datetime" placeholder="选择开始时间"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="限免结束时间" prop="EndTime">
            <el-date-picker v-model="addForm.EndTime" type="datetime" placeholder="选择结束时间" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.Remark"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <person-scope-multi-picker-dialog
        :visible.sync="personPickerVisible"
        directory-scope="teaching"
        :show-scope-tabs="false"
        :scope-department-id="DepartmentId"
        title="选择学生"
        :value="personSelectedItems"
        @confirm="onPersonsPicked"
      />

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getFreeUserManageListPage, addFreeUserManage, deleteFreeUserManage } from '../../api/modules/consumption';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'

export default {
  components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      personSelectedItems: [],
      personPickerVisible: false,
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        BeignTime: '',
        EndTime: '',
        Sort: 0,
        DepartmentId: 0,
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        DeviceType: [
          { required: true, type: 'array', min: 1, message: '请至少选择一个设备类型', trigger: 'change' }
        ],
        StartTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        EndTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ],
      },
      //新增界面数据
      addForm: {
        Sort: 0,
        DepartmentId: 0,
        StartTime: "",
        EndTime: "",
        DeviceType: [],
        Remark: "",
        UserIds: [],
      },

      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
    };
  },
  computed: {
    personSelectedPreview() {
      return (this.personSelectedItems || []).slice(0, 8);
    },
    personSelectedDeptCount() {
      const set = {};
      (this.personSelectedItems || []).forEach((item) => {
        if (item && item.deptId != null && item.deptId !== '')
          set[String(item.deptId)] = true;
      });
      return Object.keys(set).length;
    },
  },
  methods: {

    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ''
        ? ''
        : util.formatDate.format(
          new Date(row.CreateTime),
          'yyyy-MM-dd hh:mm:ss'
        )
    },
    formatDepartmentName(name) {
      if (!name) return '';
      const parts = name.split('/');
      if (parts.length <= 2) {
        return name;
      }
      return parts.slice(-2).join('/');
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(val, true);
        });
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        intPageSize: 50,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getFreeUserManageListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      this.options = [];
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          deleteFreeUserManage(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.addForm = {
        Remark: "",
        DepartmentId: this.DepartmentId,
        UserIds: [],
        EndTime: "",
        StartTime: "",
        DeviceType: [],
      };
      this.clearPersonSelection();
    },
    openPersonPicker() {
      if (!this.DepartmentId) {
        this.$message.warning('请先在左侧选择部门');
        return;
      }
      this.personPickerVisible = true;
    },
    onPersonsPicked(people) {
      this.personSelectedItems = (people || []).map((p) => ({
        id: String(p.id),
        name: p.name || String(p.id),
        personType: 'student',
        deptId: p.deptId != null ? String(p.deptId) : '0',
        deptLabel: p.deptLabel || '',
      }));
      this.syncUserIdsFromPersonItems();
    },
    clearPersonSelection() {
      this.personSelectedItems = [];
      if (this.addForm) this.addForm.UserIds = [];
    },
    removePersonSelected(id) {
      const key = String(id);
      this.personSelectedItems = (this.personSelectedItems || []).filter((x) => String(x.id) !== key);
      this.syncUserIdsFromPersonItems();
    },
    /** UserIds 形如 [deptId, userId][]，与后端 FreeUserDto 一致 */
    syncUserIdsFromPersonItems() {
      this.addForm.UserIds = (this.personSelectedItems || []).map((item) => [
        String(item.deptId || '0'),
        String(item.id),
      ]);
    },
    //新增
    addSubmit: function () {
      if (!this.personSelectedItems.length) {
        this.$message({ message: '请先选择人员', type: 'warning' });
        return;
      }
      this.syncUserIdsFromPersonItems();
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.DeviceType = Array.isArray(this.addForm.DeviceType) ? this.addForm.DeviceType.join(',') : '';
            addFreeUserManage(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.clearPersonSelection();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}
.muted-text {
  color: #94a3b8;
}
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
